import { useMemo } from "react";

import { LineGraphWidgetData } from "@/lib/api";

export const usePrimaryUnit = (data: LineGraphWidgetData) => {
  return useMemo(() => {
    const primaryLine = data.lines?.find((line) => !!line.data?.parameter.unit.type);
    return primaryLine?.data?.parameter.unit;
  }, [data]);
};
